import { render, staticRenderFns } from "./NotificationAppBar.vue?vue&type=template&id=041c69b0&scoped=true&"
import script from "./NotificationAppBar.vue?vue&type=script&lang=js&"
export * from "./NotificationAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041c69b0",
  null
  
)

export default component.exports